module.exports = __webpack_public_path__ + "ee2eb44c.svg";